module.exports = __webpack_public_path__ + "img/xdny.4778df0.png";